import { HttpErrorResponse } from '@angular/common/http';

import { CustomerInformationResponse } from '@features/succession/interfaces';

export interface LoadingStatus<T = undefined> {
  isLoading: boolean;
  isLoaded: boolean;
  error: T | HttpErrorResponse | undefined;
}

export const initialStatus: LoadingStatus<CustomerInformationResponse['formErrorDTO']> = {
  isLoading: false,
  isLoaded: false,
  error: undefined,
};

export interface ApiErrorMessage {
  message: string;
  code: string;
  buttons: {
    buttonBack: {
      title: string;
    };
    buttonTryAgain: {
      title: string;
    };
  };
}
